import Model from './model';

export default class UserModel extends Model {
  userName: string;
  password: string;
  routeIds: Array<IRoutes>;
  hybridRole: boolean;
  role: string;
  appName: Array<string>;
  isPasswordRested: boolean;
  personID: string;
  businessID: string;
  otp: any;
  confirm_password: any;
  Persons: Array<any>;

  constructor() {
    super();
    this.routeIds = new Array();
  }
}

//////////////////////////////
//IRoutes
//////////////////////////////
export class IRoutes {
  routeID: string;
  methods: Array<string>;

  constructor() {
  }
}
